
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface GroupedReport {
  authorId: string;
  year: number;
  quarter: number;
  reports: any[];
  totalSales: number;
  totalAmount: number;
  status: string;
  countries: Set<string>;
}

interface DeleteReportDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  reportGroup: GroupedReport | null;
  onConfirmDelete: () => void;
  isDeleting: boolean;
}

const DeleteReportDialog: React.FC<DeleteReportDialogProps> = ({
  open,
  onOpenChange,
  reportGroup,
  onConfirmDelete,
  isDeleting
}) => {
  if (!reportGroup) return null;

  const reportCount = reportGroup.reports.length;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Royalty Report{reportCount > 1 ? 's' : ''}</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete {reportCount > 1 ? `all ${reportCount} reports` : 'this report'} for Q{reportGroup.quarter} {reportGroup.year}? 
            This action cannot be undone and will permanently remove the report{reportCount > 1 ? 's' : ''} from the system.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirmDelete}
            disabled={isDeleting}
            className="bg-red-600 hover:bg-red-700"
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteReportDialog;
